import { Injectable } from '@angular/core';

/**
 * In-session map of CYOA parent segment + choice index → generated child story id.
 * Covers the gap between successful POST /v1/stories and profile list sync updating
 * `choices[].chosenStoryId` in Dexie (common on share-import + go-back flows).
 */
@Injectable({
  providedIn: 'root',
})
export class CyoaLocalBranchCacheService {
  private readonly branches = new Map<string, string>();

  private key(parentStoryId: string, choiceIndex: number): string {
    return `${parentStoryId}:${choiceIndex}`;
  }

  record(
    parentStoryId: string,
    choiceIndex: number,
    childStoryId: string,
  ): void {
    if (!parentStoryId || !childStoryId) {
      return;
    }
    const k = this.key(parentStoryId, choiceIndex);
    this.branches.set(k, childStoryId);
  }

  lookup(parentStoryId: string, choiceIndex: number): string | undefined {
    return this.branches.get(this.key(parentStoryId, choiceIndex));
  }
}
